export interface ProjectActivityLogsInput {
  companyId: string;
  projectId: string;
  pageSize?: number;
  nextKey?: string;
  searchTerm?: string;
}
